import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQEcommerceSolutionSection = () => <FAQSectionI18n translationPrefix="ecommerceSolution" />;
export default FAQEcommerceSolutionSection;
